import { Actions } from './license-generation-settings.actions'
import { fromJS } from 'immutable'
import * as LicenseGenerationSettingsTypes from './license-generation-settings.types'

export const initialState = fromJS<any>({
  isLoading: false,
  validationErrors: {},
  data: {},
})

export function licenseGenerationSettingsReducer(
  state = initialState,
  action: Actions,
) {
  switch (action.type) {
    case LicenseGenerationSettingsTypes.UPDATE_LICENSE_GENERATION_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case LicenseGenerationSettingsTypes.UPDATE_LICENSE_GENERATION_SETTINGS_SUCCESS: {
      return state.set('isLoading', false)
    }

    case LicenseGenerationSettingsTypes.UPDATE_LICENSE_GENERATION_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case LicenseGenerationSettingsTypes.FETCH_LICENSE_GENERATION_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case LicenseGenerationSettingsTypes.FETCH_LICENSE_GENERATION_SETTINGS_SUCCESS: {
      return state.set('isLoading', false).set('data', fromJS(action.payload))
    }

    case LicenseGenerationSettingsTypes.FETCH_LICENSE_GENERATION_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case LicenseGenerationSettingsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case LicenseGenerationSettingsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
